import { NotificationManager } from 'react-notifications';
import { SERVER_API } from "../../../config.json";
import Cookies from 'universal-cookie';

// let Kongapi = 'https://sapi.fpt.vn/inside-api/';

const cookies = new Cookies();
let tokenUser = cookies.get('usercode');
function tokenAPI() {
    if (tokenUser.token) {
        return tokenUser.token;
    }
    else {
        NotificationManager.error('Mời bạn đăng nhập lại');
    }
}

// function* token() {
//     const response = yield fetch('https://sapi.fpt.vn/token/GenerateToken', {
//         method: 'GET',
//         headers: {
//             'Content-Type': 'application/json',
//             'Authorization': 'Basic aW5zaWRlLWFwaTpGdGVsaXNjQDEyMw==',
//         },
//     });
//     const Data = yield response.json();
//     return Data
// }
let DataTest = [
    {
        ID: 1,
        Task: "Kế hoạch upcode production",
    },
    {
        ID: 2,
        Task: "Triển khai cicd",
    },
    {
        ID: 3,
        Task: "Upcode database",
    },
    {
        ID: 4,
        Task: "Kế hoạch upcode stagging",
    },
    {
        ID: 5,
        Task: "Kế hoạch upcode dev",
    },
];
//Main
function* GetDataMainFromApi(DataMain) {
    var test = tokenAPI();
    const response = yield fetch(SERVER_API + "api/PlanType/GetListPlanType", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + test
        },
        body: JSON.stringify(DataMain)
    });
    if (response.status === 403) {
        NotificationManager.warning("Bạn không có quyền trên chức năng này !","", 8000);
    }
    else if(response.status === 404)
    {
        NotificationManager.warning("Account đang được đăng nhập trên thiết bị khác. Vui lòng đăng nhập lại.","", 8000);
    }
    else if (response.status === 200) {
        const DataMainreturn = yield response.json();
        if (DataMainreturn.status === "OK") {
            return yield DataMainreturn.data;
        }
        else {
            return yield {};
        }
    }
}
function* GetDataKHNameFromApi(DataMain) {
    var test = tokenAPI();
    const response = yield fetch(SERVER_API + "api/PlanType/GetListKHName", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + test
        },
        body: JSON.stringify(DataMain)
    });
    const DataMainreturn = yield response.json();
    if (DataMainreturn.status === "OK") {
        return yield DataMainreturn.data;
    }
    else {
        return yield {};
    }
}

//delete
function* DeleteTemplate(ID) {
    var test = tokenAPI();
    const response = yield fetch(SERVER_API + "api/PlanType/DeletePlantype", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + test
        },
        body: JSON.stringify(ID)
    });
    if (response.status === 403) {
        NotificationManager.warning("Bạn không có quyền trên chức năng này !","", 8000);
    }
    else if(response.status === 404)
    {
        NotificationManager.warning("Account đang được đăng nhập trên thiết bị khác. Vui lòng đăng nhập lại.","", 8000);
    }
    else if (response.status === 200) {
        const DataMainreturn = yield response.json();
        if (DataMainreturn.status === "OK") {
            return yield DataMainreturn.data;
        }
        else {
            return yield {};
        }
    }
}
function* SetDataMainFromApi(DataMain) {

    if (!DataMain.StatusDelete) {
        if (!DataMain.ID) {
            let ID = 1;
            // eslint-disable-next-line
            DataTest.map((item) => {
                if (item.ID >= ID) {
                    ID = item.ID;
                }
            })
            DataTest.push({ ID: ID + 1, Task: DataMain.Task })
            NotificationManager.success("Thêm thành công");
            return true;
        }
        else {
            // eslint-disable-next-line
            DataTest.map((item) => {
                if (item.ID === DataMain.ID) {
                    item.Task = DataMain.Task;
                }
            });
            NotificationManager.success("Sửa thành công");
            return true;
        }
    }
    else {
        var index1;
        // eslint-disable-next-line
        DataTest.map((item, index) => {
            if (item.ID === DataMain.ID) {
                index1 = index;
            }
        });

        if (index1 !== undefined) {
            NotificationManager.success("Xóa thành công");
            DataTest.splice(index1, 1);
            return yield true;
        } else {
            NotificationManager.error("Task không tồn tại");
            return false;
        }
    }
    // return yield false;
}
//New
function* GetDataNewFromApi(id) {
    var test = tokenAPI();
    const response = yield fetch(SERVER_API + 'api/PlanTypeConfiguration/GetPlanTypeConfigurationByPlanTypeEdit', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + test
        },
        body: JSON.stringify({ ID: id }),
    });
    if (response.status === 403) {
        NotificationManager.warning("Bạn không có quyền trên chức năng này !","", 8000);
    }
    else if(response.status === 404)
    {
        NotificationManager.warning("Account đang được đăng nhập trên thiết bị khác. Vui lòng đăng nhập lại.","", 8000);
    }
    else if (response.status === 200) {
        const Data = yield response.json();
        return Data.data;
    }
    else {
        NotificationManager.error(response.statusText);
        return [];
    }
}
function* SetDataNewFromApi(DataNew) {
    if (!DataNew.StatusDelete) {
        if (!DataNew.ID) {
            let ID = 1;
            // eslint-disable-next-line
            DataTest.map((item) => {
                if (item.ID >= ID) {
                    ID = item.ID;
                }
            })
            DataTest.push({ ID: ID + 1, Task: DataNew.Task })
            NotificationManager.success("Thêm thành công");
            return true;
        }
        else {
            // eslint-disable-next-line
            DataTest.map((item) => {
                if (item.ID === DataNew.ID) {
                    item.Task = DataNew.Task;
                }
            });
            NotificationManager.success("Sửa thành công");
            return true;
        }
    }
    else {
        var index1;
        // eslint-disable-next-line
        DataTest.map((item, index) => {
            if (item.ID === DataNew.ID) {
                index1 = index;
            }
        });

        if (index1 !== undefined) {
            NotificationManager.success("Xóa thành công");
            DataTest.splice(index1, 1);
            return yield true;
        } else {
            NotificationManager.error("Task không tồn tại");
            return false;
        }
    }
    // return yield false;
}
//PlanConfigByStep
function* GetDataPlanConfigByStepFromApi(id, stepNumberPerform) {
    var test = tokenAPI();
    const response = yield fetch(SERVER_API + 'api/PlanTypeConfigurationMain/GetPlanTypeConfigurationMainByPlanTypeEditStep', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + test },
        body: JSON.stringify({ ID: id ? id : 0, StepNumber: stepNumberPerform }),
    });
    if (response.status === 403) {
        NotificationManager.warning("Bạn không có quyền trên chức năng này !","", 8000);
    }
    else if(response.status === 404)
    {
        NotificationManager.warning("Account đang được đăng nhập trên thiết bị khác. Vui lòng đăng nhập lại.","", 8000);
    }
    else if (response.status === 200) {
        const Data = yield response.json();
        return Data.data;
    }
    else {
        NotificationManager.error(response.statusText);
        return [];
    }
}
function* SetDataPlanConfigByStepFromApi(DataPlanConfigByStep) {
    var test = tokenAPI();
    //const response = yield fetch(SERVER_API + 'api/PlanType/SetPlanTypeConfig2222222', {
    const response = yield fetch(SERVER_API + 'api/PlanType/SetPlanTypeConfig', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + test },
        body: JSON.stringify(DataPlanConfigByStep),
    });
    if (response.status === 403) {
        NotificationManager.warning("Bạn không có quyền trên chức năng này !","", 8000);
    }
    else if(response.status === 404)
    {
        NotificationManager.warning("Account đang được đăng nhập trên thiết bị khác. Vui lòng đăng nhập lại.","", 8000);
    }
    else if (response.status === 200) {
        const Data = yield response.json();
        if (Data.status === "OK") {
            return true;
        }
        else {
            NotificationManager.error("Thêm template kế hoạch thất bại.");
            return false;
        }
    }
}
//GetEmail
function* GetDataEmailFromApi() {
    var test = tokenAPI();
    const response = yield fetch(SERVER_API + 'api/User/GetuserID', {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + test }
    });
    if (response.status === 403) {
        NotificationManager.warning("Bạn không có quyền trên chức năng này !","", 8000);
    }
    else if(response.status === 404)
    {
        NotificationManager.warning("Account đang được đăng nhập trên thiết bị khác. Vui lòng đăng nhập lại.","", 8000);
    }
    else if (response.status === 200) {
        const Data = yield response.json();
        return Data.data;
    }
    else {
        NotificationManager.error(response.statusText);
        return [];
    }
}
//CreateFuntionHygen
export const Api = {
    GetDataMainFromApi,
    SetDataMainFromApi,
    GetDataNewFromApi,
    SetDataNewFromApi,
    GetDataPlanConfigByStepFromApi,
    SetDataPlanConfigByStepFromApi,
    GetDataKHNameFromApi,
    DeleteTemplate,
    GetDataEmailFromApi
    //ExportFuntionHygen
}
